module.exports = ".ed_dec {\n    white-space: initial!important;\n}"